import config from './configuration'
import ConstantsList from '../common/SupplierConstants';

// this block needed to get the login Token and Login user _id 
let localData = localStorage.getItem('userData');
let userData={}
if(localData){
    userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getMenu";
    return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
    return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() { // This method calling from Redux
    let api_url= config.BASE_URL + 'api/getUserDetails';
    let param = {"_id" : userData.data._id}
    return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
    throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
    console.log(error.message);
}

// Common GET Method 
async function callGET(api_url) {
    return fetch(api_url,{
                method:'GET',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                }
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.responseCode !== 401){
                    // console.log(">> GET Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }            
            }).catch(error => {
                console.log(">> e", error);
                handleError(error);
            });
}

// Common POST Method
async function callPOST(api_url,param) {
    // console.log(">> check URL", api_url);
    if(!param){
        param = {}
    }
    param.timeZone = userTimezone;
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url,param) {
    // console.log(">>callPOSTUpload param ", param);
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    // 'Content-Type': 'multipart/form-data',
                    "Authorization": 'Bearer '+ userData.token,
                },
                body:param
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

// Common Post ResetPassword Method
async function callPostResetPassword(api_url, param, token) {
    // console.log(">> check URL", api_url);
    if(!param){
        param = {}
    }
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ token
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

//POST - Upload files
async function uploadFiles(param) {
    let api_url= config.BASE_URL + 'api/uploadFiles';
    return callPOSTUpload(api_url,param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
    let api_url= config.BASE_URL + 'api/getUploadedFiles';
    return callPOST(api_url,param);
}


//POST - LOGIN USER
async function login(param) {
    let api_url= config.BASE_URL + 'api/login';
    return fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.status === 200){
                    console.log(">> Service Login Data",items);
                    localStorage.setItem('token',items.token); 
                    localStorage.setItem("application", items?.data?.defaultAppCode);
                    localStorage.setItem('userData',JSON.stringify(items)); 
                    // sessionStorage.setItem('token',items.token); 
                    return items;
                }else{
                    return items;
                }
              
            }).catch(error => {
                handleError(error);
            });
}

//POST - LOGOUT USER
async function logout(param) {
    let api_url= config.BASE_URL + 'api/logout';
    return fetch(api_url,{
        method:'POST',
        headers:{
            "Content-Type":"application/json",
            "Accept":"application/json",
            "Authentication": 'Bearer '+ userData.token
        },
        body:JSON.stringify(param)
    }).then(response => {
        if (!response.ok) {
            handleResponseError(response);
        }
        return response.json();
    }).then(items => {
        console.log(">> Service Logout",items);
        localStorage.setItem('token',''); 
        localStorage.setItem('userData',''); 
        localStorage.setItem('application',''); 
        return items;
    }).catch(error => {
        handleError(error);
    });
}

/* ---------------------------- Dashboard --------------------------------*/

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/dashboard";
    return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/generateChartQuery";
    return callPOST(api_url, param);
}


/* ---------------------------- Logistics APP --------------------------------*/
//gate entry
async function addGateEntry(param) {
    let api_url= config.BASE_URL + "logistics/api/addGateEntry";
    return callPOST(api_url,param);
}
async function getGateEntryDatails(param) {
    let api_url= config.BASE_URL + "logistics/api/getGateEntryDatails";
    return callPOST(api_url,param);
}
async function updateGateEntry(param) {
    let api_url= config.BASE_URL + "logistics/api/updateGateEntry";
    return callPOST(api_url,param);
}
// master/Vehicle
async function updateTruckMaster(param) {
    let api_url= config.BASE_URL + "logistics/api/updateTruckMaster";
    return callPOST(api_url,param);
}
async function addTruckMaster(param) {
    let api_url= config.BASE_URL + "logistics/api/addTruckMaster";
    return callPOST(api_url,param);
}
async function getTruckMasterDetail(param) {
    let api_url= config.BASE_URL + "logistics/api/getTruckMasterDetail";
    return callPOST(api_url,param);
}
async function addTransporter(param) {
    let api_url= config.BASE_URL + "logistics/api/addTransporter";
    return callPOST(api_url,param);
}
// Master/Driver
async function updateDriverMaster(param) {
    let api_url= config.BASE_URL + "logistics/api/updateDriverMaster";
    return callPOST(api_url,param);
}
async function getDriverMasterDetail(param) {
    let api_url= config.BASE_URL + "logistics/api/getDriverMasterDetail";
    return callPOST(api_url,param);
}
async function addDriverMaster(param) {
    let api_url= config.BASE_URL + "logistics/api/addDriverMaster";
    return callPOST(api_url,param);
}
// Tranporter
async function addLogisticsTransport(param) {
    let api_url= config.BASE_URL + "logistics/api/addLogisticsTransport";
    return callPOST(api_url,param);
}
async function getLogisticsTransportDatails(param) {
    let api_url= config.BASE_URL + "logistics/api/getLogisticsTransportDatails";
    return callPOST(api_url,param);
}

//fuel entery
async function addLogisticsFuel(param) { 
    let api_url= config.BASE_URL + "logistics/api/addLogisticsFuel";
    return callPOST(api_url,param);
}
 
//cutomerv2
async function getCustomers(param) {
    let api_url= config.BASE_URL + "customer-v2/api/getCustomers";
    return callPOST(api_url,param);
}  

async function updateLogisticsTransport(param) {
    let api_url = config.BASE_URL + "logistics/api/updateLogisticsTransport";
    return callPOST(api_url, param);
}

async function addBunkMaster(param) {
    let api_url = config.BASE_URL + "customer-v2/api/addBunkMaster";
    return callPOST(api_url, param);
}
async function getBunkMaster(param) {
    let api_url = config.BASE_URL + "customer-v2/api/getBunkMaster";
    return callPOST(api_url, param);
}
 
// Logistics List
async function generateLogisticsQuery(param) {
    // This method calling from Redux
    let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
    return callPOST(api_url, param);
}
// Logistics List
async function generateBunk(param) {
    // This method calling from Redux
    let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
    return callPOST(api_url, param);
}

async function addBankMaster(param) {
  let api_url = config.BASE_URL + "customer-v2/api/addBankMaster";
  return callPOST(api_url, param);
}

async function deleteBankMaster(param) {
  let api_url = config.BASE_URL + "customer-v2/api/deleteBankMaster";
  return callPOST(api_url, param);
}


const func = {    
    handleResponseError,
    handleError,
    callGET,
    callPOST,
    callPOSTUpload,
    callPostResetPassword,    

    getMenuOnUserRole,
    getConfig,
    getLoginUserData,
    uploadFiles,
    getUploadedFiles,
    login,
    logout,
    
    
    generateChartQuery,
    dashboard,

    addGateEntry,
    getGateEntryDatails,
    updateGateEntry,
    // Master/Transporter
    addTransporter,
    // Master/Vehicle
    updateTruckMaster,
    addTruckMaster,
    getTruckMasterDetail,
    // Master/Driver
    updateDriverMaster,
    getDriverMasterDetail,
    addDriverMaster,
    // Transporter
    addLogisticsTransport,
    getLogisticsTransportDatails,
    
    addLogisticsFuel,
    getCustomers,
    
    addBunkMaster,
    getBunkMaster,
 
     updateLogisticsTransport,
 
    generateLogisticsQuery,
    generateBunk,
    addBankMaster,
    deleteBankMaster
};

export default func;